<template>
  <div class="container" v-if="activeProductInfo.frequentlyBoughtTogether">
    <div class="mobile-wrapper w-full mb-3">
      <Swiper ref="accessorySwiper" :options="contentOptions" class="h-full w-full">
        <SwiperSlide v-for="(accessory, index) in activeProductInfo.frequentlyBoughtTogether" :key="index">
          <div
            class="mobile-card flex border-blue-default border-1 rounded-lg mb-2 accessory-card overflow-hidden"
          >
            <a
              :href="accessory.productKey"
              class="w-full h-full flex flex-col hover:no-underline justify-center items-center"
            >
              <div class="text-center">
                <h6
                  class="text-blue-default text-22 font-semibold mt-2 "
                  v-if="accessory.productName"
                >
                  {{ accessory.productName }}
                </h6>
                <p class="text-md " v-if="accessory.productBrief">
                  {{ accessory.productBrief }}
                </p>
                <p
                  class="text-22 font-semibold mt-0"
                  v-if="accessory.productSpecsHeader"
                >
                  {{ accessory.productSpecsHeader }}
                </p>
              </div>
              <img
                v-if="accessory.productImages"
                :src="accessory.productImages.url"
                :alt="accessory.productImages.title"
                data-not-lazy
              />
            </a>
          </div>
        </SwiperSlide>
      </Swiper>
      <div class="bullets">
        <span
          v-for="(slide, index) in activeProductInfo.frequentlyBoughtTogether"
          :key="index"
          tabindex="0"
          class="bullet"
          :class="{ active: index + 1 === active }"
          @click.prevent="
            () => {
              goToSlide(index + 1);
              touched = false;
            }
          "
          @keyup.enter="
            () => {
              goToSlide(index + 1);
              touched = false;
            }
          "
        ></span>
      </div>
    </div>
    <div class="desktop-wrapper column flex flex-wrap w-full mb-3" :class="activeProductInfo.frequentlyBoughtTogether.length < 3 && 'left-overwrite'">
      <div
        v-for="(accessory, index) in activeProductInfo.frequentlyBoughtTogether"
        :key="index"
        class="flex border-blue-default border-1 rounded-lg mb-2 accessory-card overflow-hidden"
        @click="handleAccessoryProductClick(accessory)"
      >
        <span
          class="w-full h-full flex flex-col hover:no-underline justify-start items-center"
        >
        
          <div class="text-center">
            <h6
              class="text-blue-default text-22 font-semibold mt-2 "
              v-if="accessory.productName"
            >
              {{ accessory.productName }}
            </h6>
            <p class="text-sm mb-1" v-if="accessory.productBrief">
              {{ accessory.productBrief }}
            </p>
          </div>
          <img
            v-if="accessory.productImages"
            :src="accessory.productImages.url"
            :alt="accessory.productImages.title"
            data-not-lazy
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import get from "../mixins/get.js";
import { mapMutations } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import SalesforceResources from "../../../../mixins/salesforce-resources";
import SegmentResources from "../../../../mixins/segment-resources";

export default {
  mixins: [
    get,
    SalesforceResources,
    SegmentResources,
  ],

  props: {
    activeProductInfo: {
      type: Object,
      required: true
    },
    isAccessories: {
      type: Boolean,
      required: false
    },
  },

  components: {
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      active: 1,
      contentOptions: {
        loop: true,
        autoplay: {
          delay: 1000,
          disableOnInteraction: true
        },
        slidesPerView: 1,
        allowTouchMove: true,
        effect: "slide",
        on: {
          slideChange: this.handleSlideChange
        },
      },
    }
  },

  methods: {
    ...mapMutations([
        'setActiveProductFamily',
        'setActiveProductKey',
        'setActiveOfferKey',
        'setActiveProductTab'
    ]),

    setActiveProduct(accessory) {
      this.setActiveProductFamily(accessory.productFamily);
      this.setActiveProductKey(accessory.productKey);
      this.setActiveOfferKey('');
      this.setActiveProductTab("buy");
    },

    handleAccessoryProductClick(accessory) {
      this.setActiveProduct(accessory);
      this.trackAccessoryProductClick(accessory);
    },

    trackAccessoryProductClick(accessory) {
      const properties = {
        accessoryKey: accessory.productKey,
        accessoryName: accessory.productName,
        productKey: this.activeProductInfo.key,
        productName: this.activeProductInfo.name,
      }
      this.fireSegmentTrackingWithSfdcSegments('Recommended Accessories Clicked', this.sfdcSegments, properties);
    },

    goToSlide(index) {
      this.active = index;
      this.$refs && this.$refs.accessorySwiper && this.$refs.accessorySwiper.$swiper ? this.$refs.accessorySwiper.$swiper.slideTo(index) : null;
    },

    handleSlideChange() {
      this.active = this.$refs && this.$refs.accessorySwiper && this.$refs.accessorySwiper.$swiper ? this.$refs.accessorySwiper.$swiper.activeIndex : 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.accessory-card {
  width: 33%;
  max-width: 410px;
  margin-right: 35px;
  text-decoration: none;
  border-radius: 5%;

  @media (max-width: 1000px) {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }

  p {
    max-width: 250px;
  }

  &:nth-child(2) {
    max-width: 400px;
    
    @media (max-width: 1000px) {
      max-width: 546px;
      margin-right: auto;
      margin-left: auto;
    }
  }
  &:nth-child(3) {
    margin-right: 0;
  }
}
.accessory-card img {
  width: 100%;
}
.mobile-wrapper {
  @media (min-width: 736px) {
    display: none;
  }
}
.desktop-wrapper {
  display: none;
  @media (min-width: 736px) {
    display: flex;
    justify-content: center;
  }
  @media (min-width: 1360px) {
    justify-content: space-between;
  }
}

.left-overwrite {
  justify-content: flex-start !important;
}
::v-deep .bullets {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  .bullet {
    width: 12px;
    height: 12px;
    display: flex;
    border-radius: 25px;
    background-color: grey;
    margin: 16px;
    cursor: pointer;

    &.active {
      background-color: darkgrey;
    }
  }
}
.mobile-card {
  width: 90%;
}
@media only screen and (min-width: 1000px) {
  .container {
    max-width: 1350px;
  }
} 
</style>